export const capitalizeFirstLetter = (str: string) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const enumerate = (num: number, dec: string[]) => {
  if (num > 100) num = num % 100;
  if (num <= 20 && num >= 10) return dec[2];
  if (num > 20) num = num % 10;
  return num === 1 ? dec[0] : num > 1 && num < 5 ? dec[1] : dec[2];
};

export const getFileNameFromContentDisposition = (disposition: any) => {
  if (!disposition) return null;

  const quotedFilenameRegex = /filename="([^"]+)"/;
  const quotedMatch = disposition.match(quotedFilenameRegex);

  if (quotedMatch && quotedMatch[1]) {
    return quotedMatch[1];
  }

  const unquotedFilenameRegex = /filename=([^;,\s]+)/;
  const unquotedMatch = disposition.match(unquotedFilenameRegex);

  if (unquotedMatch && unquotedMatch[1]) {
    return unquotedMatch[1];
  }

  return null;
};

export const formatOrderAddress = (orderData: any) => {
  if (!orderData) return '';

  const { city, street, home, apartment } = orderData;

  const hasCity = city !== '' && city !== null;
  const hasStreet = street !== '' && street !== null;
  const hasHome = home !== '' && home !== null;
  const hasApartment = apartment !== '' && apartment !== null;

  const cityPart = hasCity
    ? `г. ${city}${hasStreet || hasHome || hasApartment ? ',' : ''}`
    : '';
  const streetPart = hasStreet ? `${street}${hasHome || hasApartment ? ',' : ''}` : '';
  const homePart = hasHome ? ` д ${home}` : '';
  const apartmentPart = hasApartment ? ` кв ${apartment}` : '';

  return `${cityPart} ${streetPart}${homePart}${apartmentPart}`.trim();
};

export const getCompanyInitials = (companyName: string, title?: boolean): string => {
  const organizationalPrefixes = [
    'ООО',
    'АО',
    'ЗАО',
    'ОАО',
    'ПАО',
    'ИП',
    'СПК',
    'ТОВ',
    'ЧП',
    'ФОП',
    'НП',
  ];

  const words = companyName
    .replace(/["""«»]/g, '')
    .split(' ')
    .filter((word) => word.length > 0);

  const meaningfulWords = words.filter(
    (word) => !organizationalPrefixes.includes(word.toUpperCase()),
  );

  if (title) {
    return meaningfulWords.join(' ');
  }

  if (meaningfulWords.length >= 2) {
    return meaningfulWords
      .slice(0, 2)
      .map((word) => word[0]?.toUpperCase())
      .filter(Boolean)
      .join('');
  }

  if (meaningfulWords.length === 1) {
    const word = meaningfulWords[0];
    return word.length >= 2
      ? word.slice(0, 2).toUpperCase()
      : word[0]?.toUpperCase() || '';
  }

  return words
    .slice(0, 2)
    .map((word) => word[0]?.toUpperCase())
    .filter(Boolean)
    .join('');
};

export const generatePassword = () => {
  const length = 12;
  const lowercase = 'abcdefghijklmnopqrstuvwxyz';
  const uppercase = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  const numbers = '0123456789';
  const symbols = '!@#$%^&*()_+-=[]{}|;:,.<>?';

  let password = '';
  password += lowercase[Math.floor(Math.random() * lowercase.length)];
  password += uppercase[Math.floor(Math.random() * uppercase.length)];
  password += numbers[Math.floor(Math.random() * numbers.length)];
  password += symbols[Math.floor(Math.random() * symbols.length)];

  const allChars = lowercase + uppercase + numbers + symbols;
  for (let i = password.length; i < length; i++) {
    password += allChars[Math.floor(Math.random() * allChars.length)];
  }

  return password
    .split('')
    .sort(() => Math.random() - 0.5)
    .join('');
};
